module.exports = "<lfwms-searchable-entity-search [serviceFactory]=\"serviceFactory\"></lfwms-searchable-entity-search>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-search/maintain-report-search.component.html
// module id = ../../../../../src/app/features/reports/maintain-report/maintain-report-home/maintain-report-search/maintain-report-search.component.html
// module chunks = main